import React, { useState, useEffect } from "react"
import styles from "./pnbutton.module.css"

const ViewSwitcher = ({ text, url: baseUrl }) => {
    const [finalUrl, setFinalUrl] = useState(baseUrl);

    useEffect(() => {
        let themeValue = new URLSearchParams(window.location.search).get('theme');
        if (!themeValue) themeValue = 'default';
        setFinalUrl(`${baseUrl}?theme=${themeValue}`);
    }, [baseUrl]);

    return (
        <a className={styles.linkContainer} href={finalUrl}>
            <div className={styles.buttonContainer}>
                <p className={styles.buttonText}>{text}</p>
            </div>
        </a>
    )
}

export default ViewSwitcher;